import { UploadOutlined } from "@ant-design/icons";
import { App, Button, Form, theme, Typography, Upload } from "antd";
import { useTranslation } from "react-i18next";
import { FileUploaderProps } from "types/integrations";

const FileUploader = ({
  name,
  label,
  note = "",
  required,
  allowPDF,
  allowCSV,
  disabled,
}: FileUploaderProps) => {
  const { t } = useTranslation();
  const { message } = App.useApp();
  const { token } = theme.useToken();

  const allowedFileTypes = ["image/jpg", "image/jpeg", "image/png"];
  let acceptedExtensions = ".jpg,.jpeg,.png";

  if (allowPDF) {
    allowedFileTypes.push("application/pdf");
    acceptedExtensions += ",.pdf";
  }

  if (allowCSV) {
    allowedFileTypes.push("text/csv");
    acceptedExtensions += ",.csv";
  }

  const beforeUpload = (file: { type: string; size: number }) => {
    const isAllowedType = allowedFileTypes.includes(file.type);
    if (!isAllowedType) {
      message.error(t("templates.integrations.flash_messages.file_extension"));
    }
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isLt2M) {
      message.error(t("templates.integrations.flash_messages.Maximum_size"));
    }

    if (!isAllowedType || !isLt2M) {
      return Upload.LIST_IGNORE;
    }

    return false;
  };

  const normalizeFile = (e: { fileList?: File[] } | File[]): File[] => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList || [];
  };

  return (
    <Form.Item
      name={name}
      label={<Typography.Text disabled={disabled}>{label}</Typography.Text>}
      rules={[
        {
          required: required,
          message: t(
            "templates.integrations.getpaid_activation.organization_info.file_required_error"
          ),
        },
      ]}
      extra={note}
      valuePropName="fileList"
      getValueFromEvent={normalizeFile}
    >
      <Upload
        disabled={disabled}
        accept={acceptedExtensions}
        beforeUpload={beforeUpload}
        maxCount={1}
      >
        <Button
          icon={<UploadOutlined />}
          disabled={disabled}
          style={{ marginBottom: token.marginXS }}
        >
          {t("forms.buttons.upload")}
        </Button>
      </Upload>
    </Form.Item>
  );
};

export default FileUploader;
